import {
  ApiResponseType,
  ResponseErrorType,
} from "../../store/api/applicationBankApi/config/config";

export type StatusArrayType = {
  [key: number]: string;
};
export const standartErrorMessagesArray: StatusArrayType = {
  400: "Данные некорректны",
  401: "Не авторизован",
  403: "Ошибка доступа",
};

// Обработка ошибок + стандартная обработка ошибок
/**
 * @description Обработчик ошибок
 * @param responce - Ответ сервера
 * @param exceptionsArray - Массив ошибок, у которых есть кастомный ответ с сервера
 */
export const errorHandler = (
  response: ApiResponseType,
  exceptionsArray: number[] = []
) => {
  // Если код ошибки в ответе совпадает с кодом в массиве исключений - выводим сообщение в responce и заканчиваем
  const responceError: ResponseErrorType = response.error;
  const { data, status } = responceError;

  if (exceptionsArray.length && exceptionsArray.includes(status)) {
    return data.message;
  }

  // Если ошибка не в исключениях, обрабатываем стандартные ошибки
  const standartMessage = standartErrorMessagesArray[status];
  if (standartMessage) {
    return standartMessage;
  }
};
